import client from './client';

export const adminLogin      = (data) => client.post('/auth/admin/login', data);
export const userLogin       = (data) => client.post('/auth/user/login', data);
export const forgotPassword  = (data) => client.post('/auth/forgot-password', data);
export const verifyForgotOTP = (data) => client.post('/auth/verify-forgot-otp', data);
export const resetPassword   = (data) => client.post('/auth/reset-password', data);
export const getMe           = ()     => client.get('/auth/me');
export const impersonate     = (userId) => client.post(`/auth/impersonate/${userId}`);